import DecedentProfile from '@/pages/decedent-profile/DecedentProfile';

export default DecedentProfile;
